module.exports = Redux;